import { AssessmentResultDrug, AssessmentResultType, Drugs } from '../../types/assessment';

export type RecommendationDecisionMap = Partial<Record<Drugs, boolean | null>>;

export type ResolvedDoseFormState = {
  currentMorphineDose: string;
  currentClonidineDose: string;
  currentClonidineFrequency: number | null;
};

const formatDoseValue = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '';

  return String(value);
};

const resolveDrugDose = (
  drugInfo: AssessmentResultDrug | undefined,
  recommendationDecisions: RecommendationDecisionMap | undefined,
): string => {
  if (!drugInfo) return '';

  const decision = recommendationDecisions?.[drugInfo.drug_id as Drugs] ?? drugInfo.has_accepted_recommendation;

  if (decision === true) return formatDoseValue(drugInfo.recommendation_dosage_mcg);
  if (decision === false) return formatDoseValue(drugInfo.before_recommendation_dosage_mcg);

  return '';
};

const resolveClonidineFrequency = (
  drugInfo: AssessmentResultDrug | undefined,
  recommendationDecisions: RecommendationDecisionMap | undefined,
): number | null => {
  if (!drugInfo) return 0;

  const decision = recommendationDecisions?.[drugInfo.drug_id as Drugs] ?? drugInfo.has_accepted_recommendation;

  if (decision === true) return drugInfo.recommendation_frequency ?? 0;
  if (decision === false) return drugInfo.before_recommendation_frequency ?? 0;

  return 0;
};

export const resolveDoseFormState = (
  lastResult: AssessmentResultType,
  recommendationDecisions?: RecommendationDecisionMap,
): ResolvedDoseFormState => {
  const morphineDoseInfo = lastResult.assessment_result_drug.find(drug => drug.drug_id === Drugs.Morphine);
  const clonidineDoseInfo = lastResult.assessment_result_drug.find(drug => drug.drug_id === Drugs.Clonidine);

  return {
    currentMorphineDose: resolveDrugDose(morphineDoseInfo, recommendationDecisions),
    currentClonidineDose: resolveDrugDose(clonidineDoseInfo, recommendationDecisions),
    currentClonidineFrequency: resolveClonidineFrequency(clonidineDoseInfo, recommendationDecisions),
  };
};
